import request from '../request'
import requestUrl from '../requestUrl'
import requestParam from '../requestParam'
import { serviceWithHeader } from '../request'

export const queryHomePageAllPbcNum = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/queryHomePageAllPbcNum'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryPbcStatus = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/queryPbcStatus'),
        method: 'post',
        data: requestParam(params)
    })
}

export const getTopicList = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/queryTopicList'),
        method: 'post',
        data: requestParam(params)
    })
}

export const getFinalData = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/queryPbcGroup'),
        method: 'post',
        data: requestParam(params)
    })
}

export const getSourceFinalData = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/queryPbcOfSource'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryPbcOfSourceOrResponsibleUser = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/queryPbcOfSourceOrResponsibleUser'),
        method: 'post',
        data: requestParam(params)
    })
}

export const uploadPbcFiles = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/uploadPbcFiles'),
        method: 'post',
        data: params,
        timeout: 900000,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const downloadPbcFiles = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/downloadPbcFiles'),
        method: 'post',
        data: params,
        responseType: 'blob'
    })
}

export const exportTableList = (params) => {
    return serviceWithHeader({
        url: requestUrl('/sys/pbcGroup/export'),
        method: 'post',
        data: params,
        responseType: 'blob'
    })
}

export const queryPbcSourceTypes = () => {
    return request({
        url: requestUrl('/client/pbcGroup/queryPbcSourceType'),
        method: 'post'
    })
}

export const queryPbcSourceTypeAndStatus = () => {
    return request({
        url: requestUrl('/client/pbcGroup/queryPbcSourceTypeAndStatus'),
        method: 'post'
    })
}

export const clientExportTableList = (params) => {
    return serviceWithHeader({
        url: requestUrl('/client/pbcGroup/export'),
        method: 'post',
        data: params,
        responseType: 'blob'
    })
}

export const updatePbcConfirmDay = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/changePbcConfirmDay'),
        method: 'post',
        data: requestParam(params)
    })
}

export const checkDownloadRight = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/checkDownloadRight'),
        method: 'post',
        data: requestParam(params)
    })
}
export const checkBatchDownloadRight = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/checkBatchDownloadRight'),
        method: 'post',
        data: requestParam(params)
    })
}

export const downloadPbcFilesGet = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/downloadTest'),
        method: 'get',
        params
    })
}

export const deletePbcFiles = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/deletePbcFiles'),
        method: 'post',
        data: requestParam(params)
    })
}

export const updateStatus = (params) => {
    return request({
        url: requestUrl('/sys/pbcGroup/changePbcStatus'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryInitPbcDetail = (params) => {
    return request({
        url: requestUrl('/sys/pbcGroup/queryInitPbcDetail'),
        method: 'post',
        data: requestParam(params)
    })
}

export const addPbcGroup = (params) => {
    return request({
        url: requestUrl('/sys/pbcGroup/addPbcGroup'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryPbcList = (params) => {
    return request({
        url: requestUrl('/sys/pbcGroup/queryPbcList'),
        method: 'post',
        data: requestParam(params)
    })
}

export const deletePbcGroup = (params) => {
    return request({
        url: requestUrl('/sys/pbcGroup/deletePbcGroup'),
        method: 'post',
        data: requestParam(params)
    })
}

export const updatePbcGroup = (params) => {
    return request({
        url: requestUrl('/sys/pbcGroup/updatePbcGroup'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryInterimPbc = (params) => {
    return request({
        url: requestUrl('/sys/pbcGroup/queryInterimPbc'),
        method: 'post',
        data: requestParam(params)
    })
}

export const copyFromInterim = (params) => {
    return request({
        url: requestUrl('/sys/pbcGroup/copyInterim'),
        method: 'post',
        data: requestParam(params)
    })
}

export const updatePbcSourceType = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/changePbcSourceType'),
        method: 'post',
        data: requestParam(params)
    })
}

export const deleteTopic = (params) => {
    return request({
        url: requestUrl('/sys/pbcGroup/deleteTopic'),
        method: 'post',
        data: requestParam(params)
    })
}

// export const downloadPBCFile = params => {
//     return request({
//         url: requestUrl(`/file/free/downloadGet?siteId=${params.siteId}&bindId=${params.id}&tempToken=${params.data}&&fileId=${params.fileId}`),
//         method: 'get',
//         responseType:'blob'
//     });
// }

export const downloadPBCFile = (params) => {
    return serviceWithHeader({
        url: requestUrl(`/file/free/downloadGet`),
        method: 'get',
        params: requestParam(params)
        // responseType: 'blob'
    })
}

export const downloadMultipleFilesAsZip = (params) => {
    return serviceWithHeader({
        url: requestUrl(`/file/free/downloadMultipleFilesAsZip`),
        method: 'post',
        data: params,
        responseType: 'blob'
    })
}

export const changePbcDueDay = (params) => {
    return request({
        url: requestUrl('/sys/pbcGroup/changePbcDueDay'),
        method: 'post',
        data: requestParam(params)
    })
}

export const updatePersonInCharge = (params) => {
    return request({
        url: requestUrl('/sys/pbcGroup/updatePersonInCharge'),
        method: 'post',
        data: requestParam(params)
    })
}
// 获取留言
export const queryPbcMessageBoard = (params) => {
    return request({
        url: requestUrl(`/client/pbcGroupEntityTopicMessage?t=${new Date().getTime()}&groupEntityTopicId=${params.groupEntityTopicId}`),
        method: 'get'
        // data: requestParam(params)
    })
}

// 发送留言
export const sendSinglePbcMessageBoard = (params) => {
    return request({
        url: requestUrl('/client/pbcGroupEntityTopicMessage'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryTodayCount = (params) => {
    return request({
        url: requestUrl('/client/pbcGroupEntityTopicMessage/queryTodayCount'),
        method: 'post',
        data: requestParam(params)
    })
}

// 删除留言
export const deleteSinglePbcMessageBoard = (params) => {
    return request({
        url: requestUrl('/client/pbcGroupEntityTopicMessage'),
        method: 'delete',
        data: params
    })
}

// 获取信息
export const getConfig = (params) => {
    return request({
        url: requestUrl('/client/userConfig/get'),
        method: 'post',
        data: requestParam(params)
    })
}

// 获取查询条件
export const getQueryCondition = (params) => {
    return request({
        url: requestUrl('/client/userConfig/getSiteUserBind'),
        method: 'post',
        data: requestParam(params)
    })
}

// 设置查询条件
export const setQuery = (params) => {
    return request({
        url: requestUrl('/client/userConfig/queryCondition'),
        method: 'post',
        data: requestParam(params)
    })
}

// 设置超时时间
export const setTime = (params) => {
    return request({
        url: requestUrl('/client/userConfig/sessionTime'),
        method: 'post',
        data: requestParam(params)
    })
}

//查询文件历史记录
export const queryFileHistory = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/queryFileHistoty'),
        method: 'post',
        data: requestParam(params)
    })
}

//查询当前用户未下载文件
export const queryNoDownLoad = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/queryNoDownLoad'),
        method: 'post',
        data: requestParam(params)
    })
}

// 反向赋权
export const reverseAccount = (params) => {
    return request({
        url: requestUrl('/sys/pbcGroup/reverseAccount'),
        method: 'post',
        data: requestParam(params)
    })
}

// 修改定制
export const updatePbcAccount = (params) => {
    return request({
        url: requestUrl('/sys/pbcGroup/updatePbcAccount'),
        method: 'post',
        data: requestParam(params)
    })
}

// 获取饼图信息
export const getPieData = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/pbcDashBoard'),
        method: 'post',
        data: requestParam(params)
    })
}

// 获取表格信息
export const getDashTable = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/pbcListView'),
        method: 'post',
        data: requestParam(params)
    })
}

// 下载account模板
export const downloadAccountTemplate = (params) => {
    return request({
        url: requestUrl('/sys/pbcGroup/download/account/template'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}

// 导入account
export const uploadAccountFile = (params) => {
    return request({
        url: requestUrl('/sys/pbcGroup/accountImport'),
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const sendPbcFileNotificationEmail = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/sendPbcFileNotificationEmail'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryTodayCommentInfos = (params) => {
    return request({
        url: requestUrl('/client/pbcGroup/queryTodayCommentInfos'),
        method: 'post',
        data: requestParam(params)
    })
}